import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorRedirectRoute: InvariantJiraRoute = {
	name: 'legacy-gin-quicksearch',
	path: '/secure/QuickSearch.jspa',
	query: ['searchString'],
};
